//
// // src/components/Calendar/CalendarView.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import "./CalendarView.css";
// import { getCalendarData } from "@/api/calendarApi";
// import { Spin, message } from "antd";
//
// /**
//  * CalendarView Component
//  * Displays a calendar with colored dots indicating tasks on specific dates
//  * Color mapping:
//  * - Sariq: PENDING tasks
//  * - Ko'k: IN_PROGRESS tasks
//  * - To'q sariq: SUBMITTED tasks
//  * - Yashil: APPROVED tasks
//  * - Qizil: REJECTED tasks
//  */
// const CalendarView = ({ onDateClick, isAdmin = false }) => {
//   const [date, setDate] = useState(new Date());
//   const [calendarData, setCalendarData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [activeMonth, setActiveMonth] = useState(new Date());
//
//   const calendarByDate = useMemo(() => {
//     const map = new Map();
//     (calendarData || []).forEach((item) => {
//       if (item?.date) {
//         map.set(item.date, item);
//       }
//     });
//     return map;
//   }, [calendarData]);
//
//   // Fetch calendar data when month changes
//   useEffect(() => {
//     fetchCalendarData();
//   }, [activeMonth]);
//
//   const fetchCalendarData = async () => {
//     setLoading(true);
//     try {
//       // Get first and last day of the month
//       const startDate = new Date(
//         activeMonth.getFullYear(),
//         activeMonth.getMonth(),
//         1
//       );
//       const endDate = new Date(
//         activeMonth.getFullYear(),
//         activeMonth.getMonth() + 1,
//         0
//       );
//
//       const startStr = startDate.toISOString().split("T")[0];
//       const endStr = endDate.toISOString().split("T")[0];
//
//       const data = await getCalendarData(startStr, endStr);
//       setCalendarData(data.dates || []);
//     } catch (error) {
//       console.error("Error fetching calendar data:", error);
//       message.error("Kalendar ma'lumotlarini yuklashda xatolik");
//     } finally {
//       setLoading(false);
//     }
//   };
//
//   // Handle date click
//   const handleDateClick = (clickedDate) => {
//     setDate(clickedDate);
//     if (onDateClick) {
//       const dateStr = clickedDate.toISOString().split("T")[0];
//       onDateClick(dateStr);
//     }
//   };
//
//   // Handle month/year change
//   const handleActiveStartDateChange = ({ activeStartDate }) => {
//     setActiveMonth(activeStartDate);
//   };
//
//   // Get task data for a specific date
//   const getTaskDataForDate = (date) => {
//     // Local sanani YYYY-MM-DD formatiga o'girish (UTC emas!)
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const dateStr = `${year}-${month}-${day}`;
//     return calendarByDate.get(dateStr);
//   };
//
//   // Determine which status has the most tasks (for primary color)
//   const getPrimaryStatus = (taskData) => {
//     if (!taskData || taskData.total === 0) return null;
//
//     const statuses = [
//       { name: "rejected", count: taskData.rejected },
//       { name: "pending", count: taskData.pending },
//       { name: "submitted", count: taskData.submitted },
//       { name: "in_progress", count: taskData.in_progress },
//       { name: "approved", count: taskData.approved },
//     ];
//
//     // Priority order: rejected > pending > submitted > in_progress > approved
//     const sorted = statuses.sort((a, b) => b.count - a.count);
//     return sorted[0].count > 0 ? sorted[0].name : null;
//   };
//
//   // Add custom styling to calendar tiles
//   const tileContent = ({ date, view }) => {
//     if (view === "month") {
//       const taskData = getTaskDataForDate(date);
//       if (!taskData) return null;
//
//       const dots = [];
//
//       if (taskData.pending > 0) {
//         dots.push(<span key="pending" className="status-dot pending" title={`Kutilmoqda: ${taskData.pending}`} />);
//       }
//       if (taskData.in_progress > 0) {
//         dots.push(<span key="in_progress" className="status-dot in-progress" title={`Jarayonda: ${taskData.in_progress}`} />);
//       }
//       if (taskData.submitted > 0) {
//         dots.push(<span key="submitted" className="status-dot submitted" title={`Yuborilgan: ${taskData.submitted}`} />);
//       }
//       if (taskData.approved > 0) {
//         dots.push(<span key="approved" className="status-dot approved" title={`Tasdiqlangan: ${taskData.approved}`} />);
//       }
//       if (taskData.rejected > 0) {
//         dots.push(<span key="rejected" className="status-dot rejected" title={`Rad etilgan: ${taskData.rejected}`} />);
//       }
//
//       const hasTasks = taskData.total > 0;
//       const eventCount = taskData.event_count || 0;
//       const eventClass = taskData.has_past_event && taskData.has_upcoming_event
//         ? "mixed"
//         : taskData.has_past_event
//           ? "past"
//           : "upcoming";
//
//       return (
//         <div className="tile-content">
//           {hasTasks && dots.length > 0 && <div className="status-dots">{dots}</div>}
//           {hasTasks && <div className="task-count">{taskData.total}</div>}
//           {eventCount > 0 && (
//             <div className={`event-indicator ${eventClass}`} title={`${eventCount} ta tadbir`}>
//               <span className="event-dot" />
//               <span className="event-count">{eventCount}</span>
//             </div>
//           )}
//         </div>
//       );
//     }
//     return null;
//   };
//
//   // Add custom class names to tiles based on status
//   const tileClassName = ({ date, view }) => {
//     if (view === "month") {
//       const taskData = getTaskDataForDate(date);
//       if (!taskData) return null;
//       const classes = [];
//       if (taskData.total > 0) {
//         classes.push("has-tasks");
//         const primaryStatus = getPrimaryStatus(taskData);
//         if (primaryStatus) {
//           classes.push(`status-${primaryStatus}`);
//         }
//       }
//
//       if ((taskData.event_count || 0) > 0) {
//         classes.push("has-events");
//         const hasUpcoming = Boolean(taskData.has_upcoming_event);
//         const hasPast = Boolean(taskData.has_past_event);
//         if (hasUpcoming && hasPast) {
//           classes.push("event-mixed");
//         } else if (hasPast) {
//           classes.push("event-past");
//         } else {
//           classes.push("event-upcoming");
//         }
//       }
//
//       return classes.length ? classes.join(" ") : null;
//     }
//     return null;
//   };
//
//   return (
//     <div className="calendar-view-container">
//       {loading && (
//         <div className="calendar-loading-overlay">
//           <Spin size="large" />
//         </div>
//       )}
//
//       <div className="calendar-legend">
//         <div className="legend-item">
//           <span className="legend-dot pending"></span>
//           <span>Kutilmoqda</span>
//         </div>
//         <div className="legend-item">
//           <span className="legend-dot in-progress"></span>
//           <span>Jarayonda</span>
//         </div>
//         <div className="legend-item">
//           <span className="legend-dot submitted"></span>
//           <span>Yuborilgan</span>
//         </div>
//         <div className="legend-item">
//           <span className="legend-dot approved"></span>
//           <span>Tasdiqlangan</span>
//         </div>
//         <div className="legend-item">
//           <span className="legend-dot rejected"></span>
//           <span>Rad etilgan</span>
//         </div>
//         <div className="legend-item">
//           <span className="legend-dot event-upcoming"></span>
//           <span>Kelgusi tadbir</span>
//         </div>
//         <div className="legend-item">
//           <span className="legend-dot event-past"></span>
//           <span>O'tgan tadbir</span>
//         </div>
//       </div>
//
//       <Calendar
//         onChange={handleDateClick}
//         value={date}
//         onActiveStartDateChange={handleActiveStartDateChange}
//         tileContent={tileContent}
//         tileClassName={tileClassName}
//         locale="uz-UZ"
//         className="custom-calendar"
//         formatShortWeekday={(locale, date) => ['Ya', 'Du', 'Se', 'Cho', 'Pa', 'Ju', 'Sha'][date.getDay()]}
//         formatMonth={(locale, date) => {
//           const months = [
//             'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun',
//             'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'
//           ];
//           return months[date.getMonth()];
//         }}
//         formatMonthYear={(locale, date) => {
//           const months = [
//             'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun',
//             'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'
//           ];
//           return `${date.getFullYear()}, ${months[date.getMonth()]}`;
//         }}
//         navigationLabel={({ date, view }) => {
//           const months = [
//             'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun',
//             'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'
//           ];
//           if (view === 'year') {
//             return `${date.getFullYear()}`;
//           }
//           return `${date.getFullYear()}, ${months[date.getMonth()]}`;
//         }}
//         nextLabel="›"
//         next2Label="»"
//         prevLabel="‹"
//         prev2Label="«"
//       />
//     </div>
//   );
// };
//
// export default CalendarView;

// src/components/Calendar/CalendarView.jsx
import React, { useState, useEffect, useMemo } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./CalendarView.css";
import { getCalendarData } from "@/api/calendarApi";
import { Spin, message } from "antd";

/**
 * CalendarView Component
 * Displays a calendar with colored dots indicating tasks on specific dates
 * Color mapping:
 * - Sariq: PENDING tasks
 * - Ko'k: IN_PROGRESS tasks
 * - To'q sariq: SUBMITTED tasks
 * - Yashil: APPROVED tasks
 * - Qizil: REJECTED tasks
 */
const CalendarView = ({ onDateClick, isAdmin = false }) => {
  const [date, setDate] = useState(new Date());
  const [calendarData, setCalendarData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeMonth, setActiveMonth] = useState(new Date());

  const calendarByDate = useMemo(() => {
    const map = new Map();
    (calendarData || []).forEach((item) => {
      if (item?.date) {
        map.set(item.date, item);
      }
    });
    return map;
  }, [calendarData]);

  // Fetch calendar data when month changes
  useEffect(() => {
    fetchCalendarData();
  }, [activeMonth]);

  const fetchCalendarData = async () => {
    setLoading(true);
    try {
      // Get first and last day of the month
      const startDate = new Date(
        activeMonth.getFullYear(),
        activeMonth.getMonth(),
        1
      );
      const endDate = new Date(
        activeMonth.getFullYear(),
        activeMonth.getMonth() + 1,
        0
      );

      const startStr = startDate.toISOString().split("T")[0];
      const endStr = endDate.toISOString().split("T")[0];

      const data = await getCalendarData(startStr, endStr);
      setCalendarData(data.dates || []);
    } catch (error) {
      console.error("Error fetching calendar data:", error);
      message.error("Kalendar ma'lumotlarini yuklashda xatolik");
    } finally {
      setLoading(false);
    }
  };

  // Handle date click
  const handleDateClick = (clickedDate) => {
    setDate(clickedDate);
    if (onDateClick) {
      // Local sanani YYYY-MM-DD formatiga o'girish (UTC emas!)
      const year = clickedDate.getFullYear();
      const month = String(clickedDate.getMonth() + 1).padStart(2, '0');
      const day = String(clickedDate.getDate()).padStart(2, '0');
      const dateStr = `${year}-${month}-${day}`;
      console.log('CalendarView - Bosilgan sana:', dateStr); // Debug uchun
      onDateClick(dateStr);
    }
  };

  // Handle month/year change
  const handleActiveStartDateChange = ({ activeStartDate }) => {
    setActiveMonth(activeStartDate);
  };

  // Get task data for a specific date
  const getTaskDataForDate = (date) => {
    // Local sanani YYYY-MM-DD formatiga o'girish (UTC emas!)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;
    return calendarByDate.get(dateStr);
  };

  // Determine which status has the most tasks (for primary color)
  const getPrimaryStatus = (taskData) => {
    if (!taskData || taskData.total === 0) return null;

    const statuses = [
      { name: "rejected", count: taskData.rejected },
      { name: "pending", count: taskData.pending },
      { name: "submitted", count: taskData.submitted },
      { name: "in_progress", count: taskData.in_progress },
      { name: "approved", count: taskData.approved },
    ];

    // Priority order: rejected > pending > submitted > in_progress > approved
    const sorted = statuses.sort((a, b) => b.count - a.count);
    return sorted[0].count > 0 ? sorted[0].name : null;
  };

  // Add custom styling to calendar tiles
  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const taskData = getTaskDataForDate(date);
      if (!taskData) return null;

      const dots = [];

      if (taskData.pending > 0) {
        dots.push(<span key="pending" className="status-dot pending" title={`Kutilmoqda: ${taskData.pending}`} />);
      }
      if (taskData.in_progress > 0) {
        dots.push(<span key="in_progress" className="status-dot in-progress" title={`Jarayonda: ${taskData.in_progress}`} />);
      }
      if (taskData.submitted > 0) {
        dots.push(<span key="submitted" className="status-dot submitted" title={`Yuborilgan: ${taskData.submitted}`} />);
      }
      if (taskData.approved > 0) {
        dots.push(<span key="approved" className="status-dot approved" title={`Tasdiqlangan: ${taskData.approved}`} />);
      }
      if (taskData.rejected > 0) {
        dots.push(<span key="rejected" className="status-dot rejected" title={`Rad etilgan: ${taskData.rejected}`} />);
      }

      const hasTasks = taskData.total > 0;
      const eventCount = taskData.event_count || 0;
      const eventClass = taskData.has_past_event && taskData.has_upcoming_event
        ? "mixed"
        : taskData.has_past_event
          ? "past"
          : "upcoming";

      return (
        <div className="tile-content">
          {hasTasks && dots.length > 0 && <div className="status-dots">{dots}</div>}
          {hasTasks && <div className="task-count">{taskData.total}</div>}
          {eventCount > 0 && (
            <div className={`event-indicator ${eventClass}`} title={`${eventCount} ta tadbir`}>
              <span className="event-dot" />
              <span className="event-count">{eventCount}</span>
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  // Add custom class names to tiles based on status
  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const taskData = getTaskDataForDate(date);
      if (!taskData) return null;
      const classes = [];
      if (taskData.total > 0) {
        classes.push("has-tasks");
        const primaryStatus = getPrimaryStatus(taskData);
        if (primaryStatus) {
          classes.push(`status-${primaryStatus}`);
        }
      }

      if ((taskData.event_count || 0) > 0) {
        classes.push("has-events");
        const hasUpcoming = Boolean(taskData.has_upcoming_event);
        const hasPast = Boolean(taskData.has_past_event);
        if (hasUpcoming && hasPast) {
          classes.push("event-mixed");
        } else if (hasPast) {
          classes.push("event-past");
        } else {
          classes.push("event-upcoming");
        }
      }

      return classes.length ? classes.join(" ") : null;
    }
    return null;
  };

  return (
    <div className="calendar-view-container">
      {loading && (
        <div className="calendar-loading-overlay">
          <Spin size="large" />
        </div>
      )}

      <div className="calendar-legend">
        <div className="legend-item">
          <span className="legend-dot pending"></span>
          <span>Kutilmoqda</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot in-progress"></span>
          <span>Jarayonda</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot submitted"></span>
          <span>Yuborilgan</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot approved"></span>
          <span>Tasdiqlangan</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot rejected"></span>
          <span>Rad etilgan</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot event-upcoming"></span>
          <span>Kelgusi tadbir</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot event-past"></span>
          <span>O'tgan tadbir</span>
        </div>
      </div>

      <Calendar
        onChange={handleDateClick}
        value={date}
        onActiveStartDateChange={handleActiveStartDateChange}
        tileContent={tileContent}
        tileClassName={tileClassName}
        locale="uz-UZ"
        className="custom-calendar"
        formatShortWeekday={(locale, date) => ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba'][date.getDay()]}
        formatMonth={(locale, date) => {
          const months = [
            'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun',
            'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'
          ];
          return months[date.getMonth()];
        }}
        formatMonthYear={(locale, date) => {
          const months = [
            'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun',
            'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'
          ];
          return `${date.getFullYear()}, ${months[date.getMonth()]}`;
        }}
        navigationLabel={({ date, view }) => {
          const months = [
            'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun',
            'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'
          ];
          if (view === 'year') {
            return `${date.getFullYear()}`;
          }
          return `${date.getFullYear()}, ${months[date.getMonth()]}`;
        }}
        nextLabel="›"
        next2Label="»"
        prevLabel="‹"
        prev2Label="«"
      />
    </div>
  );
};

export default CalendarView;